import React, { useState, createContext } from 'react';

// 1. Create the context with default values
export const HeaderContext = createContext({
  isHeaderAnimated: false,
  setHeaderAnimated: () => {},
  isHeaderExtended: true, // Default to extended initially
  setHeaderExtended: () => {}
});

// 2. Create a Provider component
export const HeaderProvider = ({ children }) => {
  const [isHeaderAnimated, setIsHeaderAnimated] = useState(false);
  const [isHeaderExtended, setIsHeaderExtended] = useState(true); // Initial state

  // Memoize the context value if needed, but for simple state setters it's often okay
  const value = {
    isHeaderAnimated,
    setHeaderAnimated: setIsHeaderAnimated, // Pass the actual state setter
    isHeaderExtended,
    setHeaderExtended: setIsHeaderExtended // Pass the actual state setter
  };

  return (
    <HeaderContext.Provider value={value}>
      {children}
    </HeaderContext.Provider>
  );
};